import { stores } from '@stores'
import { action, observable } from 'mobx'
import EnhancedListDataService from '@modules/order/services/EnhancedListDataService'
import { findIndex, pullAllWith } from 'lodash'
import { QUANTITY_TYPE_WARNING_MAPPING } from '@components/UI-Components/QuantityType/constants/QuantityType'

export class EnhancedWarningPopupStore {
  @observable mandatoryWarningAttributes = []
  @observable warningDropdownFilters = []
  @observable appliedWarningFilterOption = null
  @observable isEnhancedWarningActive = false
  @observable warningFiltersLoading = true

  @action
  setAppliedWarningFilterOption = warningOption => {
    this.appliedWarningFilterOption = warningOption
    this.toggleEnhancedWarningModal()
  }

  @action
  toggleEnhancedWarningModal = (...args) => {
    if (args?.length) {
      this.isEnhancedWarningActive = args[0]
    } else {
      this.isEnhancedWarningActive = !this.isEnhancedWarningActive
    }
  }

  @action
  getValidationWarningsAttributes = () => {
    const {
      productConfiguration: { getOrderValidationWarningsAttributes, defaultQuantityType }
    } = stores
    const temp = getOrderValidationWarningsAttributes()
    if (defaultQuantityType) {
      const unSelectedArray = Object.keys(QUANTITY_TYPE_WARNING_MAPPING).reduce(
        (acc, type) => {
          if (type !== defaultQuantityType) {
            acc.push(QUANTITY_TYPE_WARNING_MAPPING?.[type])
          }
          return acc
        },
        []
      )
      pullAllWith(
        temp,
        unSelectedArray,
        (warningFilter, unSelected) => warningFilter?.filterName === (unSelected || '')
      )
    }
    this.mandatoryWarningAttributes = temp
  }

  @action
  fetchOrderWarningsForDropdown = isInitialLoad => {
    const {
      nav: {
        queryParams: { buyingSessionGroupId, orderId, orderType, clientOrderId }
      },
      productConfiguration: { defaultQuantityType }
    } = stores
    const service = new EnhancedListDataService()
    return service
      .fetchOrderWarningSummary(
        buyingSessionGroupId,
        orderId,
        orderType,
        clientOrderId,
        defaultQuantityType
      )
      .then(resp => {
        const filterData =
          resp?.filter(
            el =>
              el.count || this.appliedWarningFilterOption?.filterName === el?.filterName
          ) || []
        this.warningDropdownFilters = filterData
        if (!this.appliedWarningFilterOption) {
          this.appliedWarningFilterOption = filterData[0] || null //default selection should be first warning filter
        } else {
          const appliedFilterIndex = findIndex(
            filterData,
            (el: any) => el?.filterName === this.appliedWarningFilterOption?.filterName
          )
          if (
            appliedFilterIndex !== -1 &&
            this.appliedWarningFilterOption?.count !==
              filterData[appliedFilterIndex]?.count
          ) {
            this.appliedWarningFilterOption = filterData[appliedFilterIndex]
          }
        }
        this.warningFiltersLoading = false
        if (isInitialLoad) {
          this.toggleEnhancedWarningModal(true)
        }
      })
  }
}
